import { getjQuery } from "@serenity-is/corelib";
import { DroughtMapLogic } from "../../Drought/Map/MapLogic";

let $ = getjQuery();
$(function () {
    var dash = new DroughtMapLogic();
    dash.CreateDroughtMap();
});
